import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { UserServiceComission } from './user-service-comission'

export class UserServiceComissionsRepository extends BaseRepository<UserServiceComission> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/user-service-comissions', token, cache)
    }

    async getByUser(userId: string): Promise<UserServiceComission[]> {
        const { json, statusCode, message } = await this.request.get(
            this.config.posApiUrl + '/user-service-comissions/?userId=' + userId + '&token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    // salva em lote a tabela de um profissional. linha com os 6 campos nulos é removida no backend (volta a
    // herdar tudo do serviço); serviços não enviados ficam como estão.
    async saveByUser(userId: string, items: UserServiceComission[]): Promise<UserServiceComission[]> {
        const { json, statusCode, message } = await this.request.put(
            this.config.posApiUrl + '/user-service-comissions/users/' + userId + '?token=' + this.resolvedToken,
            { items },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
